import Api from './Api';

export default {
    createOrder(req) {
        const api = Api.generateApi();
        return api.post('order/confirm', req).then(res => res);
    }
};